import { FieldDef } from '@core/models';
import { Store } from '@ngxs/store';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';
import { Operator } from 'tsui';

export function getLinkedField(store: Store, mainObjectName: string, recordObjectName: string): FieldDef {
  return store
    .selectSnapshot(
      ObjectsManagerState.getFieldsByObjectName(mainObjectName, {
        allowedFieldsOnly: true,
        addNestedFields: false,
      }),
    )
    .find((x) => x.name.startsWith('cf_linked_') && x.type === 'record' && x.meta.record_type === recordObjectName);
}

export function getFjson(field: string, operator: Operator, value: any): string {
  return `[["${field}", "${operator}", "${value}"]]`;
}

export function getLinkedFieldAsFjson(
  store: Store,
  mainObjectName: string,
  recordObjectName: string,
  relatedToId: number,
): [string, string, any] {
  const linkedField = getLinkedField(store, mainObjectName, recordObjectName);
  return JSON.parse(getFjson(`${linkedField.name}.id`, 'in', relatedToId));
}
